import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);


/********** 
パララックス効果 
**********/
window.addEventListener("load", () => {
  // Webフォントの読み込みを待つ（読み込み完了後に処理）
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initParallax);
  } else {
    initParallax();
  }
});

function initParallax() {
  const parallaxUpElements = gsap.utils.toArray('.js-parallax-up');
  parallaxUpElements.forEach((element) => {
    gsap.to(element, {
      yPercent: -8,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
    });
  });

  const parallaxDownElements = gsap.utils.toArray('.js-parallax-down');
  parallaxDownElements.forEach((element) => {
    gsap.to(element, {
      yPercent: 5,
      ease: "none",
      scrollTrigger: {
        trigger: element,
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
    });
  });

  // iOS Safari 対策：強制的に ScrollTrigger を再計算
  ScrollTrigger.refresh();
}



/**********
実績セクション パララックス背景（TOP・ABOUT共通）
**********/
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".p-top-results, .p-about-results");
  if (!sections.length) return;

  sections.forEach((section) => {
    gsap.fromTo(
      section,
      { "--bgY": "0rem" },
      {
        "--bgY": "-3rem",
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.5,
        },
      }
    );
  });
});

/********** 
トップページメインビューFIXアニメーション
**********/
document.addEventListener("DOMContentLoaded", () => {
  const fvBg = document.querySelector(".js-fv_bg");
  const fvHeight = document.querySelector(".js-fv_height");
  if (!fvBg || !fvHeight) return;

  gsap.fromTo(
    fvBg,
    { scale: 1 },
    {
      scale: 1.1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: fvHeight,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    }
  );
});


/**********
オープニングアニメーション（デバッグ切り替え）
**********/

document.addEventListener("DOMContentLoaded", () => {
  const DEBUG_MODE = false;

  if (!DEBUG_MODE && sessionStorage.getItem("openingPlayed")) {
    document.querySelector(".js-loading")?.remove();
    document.querySelectorAll(".p-top-mv__catch-wrap, .p-top-mv__title-wrap").forEach(el => {
      gsap.set(el, { opacity: 1 });
    });
    const titleWrap = document.querySelector(".p-top-mv__title-wrap");
    if (titleWrap) {
      gsap.set(titleWrap, {
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
      });
    }
    return;
  }

  if (!DEBUG_MODE) sessionStorage.setItem("openingPlayed", "true");

  const loading = document.querySelector(".js-loading");
  const img = document.querySelector(".p-loading__img");
  const text01 = document.querySelector(".p-loading__text01");
  const text02 = document.querySelector(".p-loading__text02");

  // 要素がすべて存在する場合のみアニメーションを実行
  if (loading && img && text01 && text02) {
    // 初期状態
    gsap.set([img, text01, text02], { opacity: 0 });
    gsap.set([text01, text02], {
      clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)",
    });

    const tl = gsap.timeline({
      defaults: { ease: "power2.out" },
      onComplete: () => {
        setTimeout(() => loading.remove(), 800);
      },
    });

    tl
      .set(loading, { opacity: 1 })
      .to({}, { duration: 0.3 })
      .to(img, { opacity: 1, duration: 0.8 })

      .to(text01, {
        opacity: 1,
        duration: 1.5,
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        ease: "expo.out",
      }, "-=0.2")

      .to(text02, {
        opacity: 1,
        duration: 1.0,
        clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        ease: "power3.out",
      }, "-=0.5")

      .to({}, { duration: 0.2 })
      .to([loading, img, text01, text02], {
        opacity: 0,
        duration: 0.6,
        ease: "power2.inOut"
      })

      .add(() => {
        loading.classList.add("is-hide");
        document.dispatchEvent(new Event("loadingAnimationComplete"));
      }, "-=0.5");
  }
});



/**********
MVアニメーション（ローディング完了後）
**********/
document.addEventListener("loadingAnimationComplete", () => {
  gsap.registerPlugin(SplitText);

  const titleWrap = document.querySelector(".p-top-mv__title-wrap");
  const catchWrap = document.querySelector(".p-top-mv__catch-wrap");

  if (titleWrap) {
    gsap.set(titleWrap, {
      clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
      opacity: 0,
    });
  }
  if (catchWrap) {
    gsap.set(catchWrap, { opacity: 0 });
  }

  const catchEl = document.querySelector(".p-top-mv__catch");
  if (!catchEl) return;

  const split = new SplitText(catchEl, { type: "chars" });
  gsap.set(split.chars, { y: -20, autoAlpha: 0 });

  const lineEl = document.querySelector(".p-top-mv__catch-line");
  if (lineEl) {
    const isSp = window.innerWidth <= 767;
    gsap.set(lineEl, {
      scale: 0,
      transformOrigin: isSp ? "left" : "top",
    });
  }

  const tl = gsap.timeline();

  if (catchWrap) {
    tl.to(catchWrap, {
      opacity: 1,
      duration: 0.6,
      ease: "power1.out",
    });
  }

  if (titleWrap) {
    tl.to(titleWrap, {
      opacity: 1,
      clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
      duration: 2.5,
      ease: "expo.out",
    });
  }

  // メインキャッチのみのアニメーション
  tl.to(
    split.chars,
    {
      y: 0,
      autoAlpha: 1,
      duration: 0.6,
      ease: "power2.out",
      stagger: 0.05,
    },
    "-=0.8"
  );

  if (lineEl) {
    tl.to(
      lineEl,
      {
        scale: 1,
        duration: 0.6,
        ease: "power2.out",
      },
      "-=0.6"
    );
  }
});
